<div *ngIf="!showBackorderCartModal" class="modal-container product-list-modal-container modal-lg">
  <div class="modal-content align-items-center">
    <div class="modal-header">
      <button class="close" aria-label="Close" (click)="closeModal('Cross click')">
        <mat-icon svgIcon="modal-x-icon"></mat-icon>
      </button>
    </div>
    <div *ngIf="!isMobileSize" [ngTemplateOutlet]="skuNameArea"></div>
    <ng-template #skuNameArea>
      <div class="sku-name">
        <app-tooltip-text
          class="prod-name-grid-modal"
          [tooltipContent]="product?.name"
          [content]="product?.name"
          placement="bottom"
        >
        </app-tooltip-text>
      </div>
      <div *ngIf="product" class="article-number-wrapper">
        <div class="sku-article-label">
          {{ 'product.productSummary.code' | cxTranslate }}
        </div>
        <div class="sku-article-number">
          {{ product?.code }}
        </div>
      </div>
    </ng-template>
    <div class="modal-body">
      <div class="sku-image-name">
        <div class="sku-image">
          <div>
            <cx-media
              *ngIf="product?.code"
              class="cx-product-image"
              [container]="getImageRendition(getFirstVariantProductImageAltText(product?.code))"
              format="string"
              [alt]="product?.baseProductName"
              [class.is-missing-fish]="businessType === 'fish'"
            ></cx-media>
          </div>
        </div>
        <div *ngIf="isMobileSize" [ngTemplateOutlet]="skuNameArea"></div>
        <div *ngIf="!isMobileSize" [ngTemplateOutlet]="stockStatusArea"></div>
        <ng-template #stockStatusArea>
          <div class="stock-status-grid-modal">
            <ng-container *ngIf="product">
              <ng-container *ngIf="salesRepStockData(product?.salesRepStockData)" [ngSwitch]="product['inStockFlag']">
                <div class="stock-info" *ngSwitchCase="true">
                  <span class="text instock-text">{{ 'product.stockInfo.inStockMessage' | cxTranslate }}</span>
                  <span
                    *ngIf="product?.leadTime > 0 && product?.stock?.stockLevelStatus === 'inStock'"
                    class="leadtime-text"
                    >{{ 'product.stockInfo.leadtimeInstock' | cxTranslate : { unit: product?.leadTime } }}
                    {{ 'product.stockInfo.day' | cxTranslate }}
                  </span>
                  <span
                    *ngIf="product?.leadTime > 0 && product?.stock?.stockLevelStatus === 'backorder'"
                    class="leadtime-text"
                    >{{ 'product.stockInfo.leadtimeInstock' | cxTranslate : { unit: product?.leadTime } }}
                    {{ 'product.stockInfo.day' | cxTranslate }}
                  </span>
                </div>
                <ng-container *ngSwitchCase="false">
                  <ng-container *ngIf="product?.stock?.stockLevelStatus == 'backorder'; else outOfStock">
                    <div class="stock-info">
                      <span class="text backorder-text">{{ 'product.stockInfo.backorderMessage' | cxTranslate }}</span>
                      <span
                        *ngIf="product?.leadTime > 0 && product?.stock?.stockLevelStatus === 'inStock'"
                        class="leadtime-text"
                        >{{ 'product.stockInfo.leadtimeInstock' | cxTranslate : { unit: product?.leadTime } }}
                        {{ 'product.stockInfo.day' | cxTranslate }}
                      </span>
                      <span
                        *ngIf="product?.leadTime > 0 && product?.stock?.stockLevelStatus === 'backorder'"
                        class="leadtime-text"
                        >{{ 'product.stockInfo.leadtimeInstock' | cxTranslate : { unit: product?.leadTime } }}
                        {{ 'product.stockInfo.day' | cxTranslate }}
                      </span>
                    </div>
                  </ng-container>
                  <ng-template #outOfStock>
                    <div class="stock-info-error">
                      <mat-icon class="error-icon">error</mat-icon>
                      <span class="error-text">{{ 'product.stockInfo.outOfStockMessage' | cxTranslate }}</span>
                    </div>
                  </ng-template>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="product?.salesRepStockData">
                <ng-container
                  *ngFor="let warehouse of checkSalesRepStockData(product?.salesRepStockData)"
                  [ngSwitch]="warehouse.stockLevelStatus"
                >
                  <div class="stock-info-error" *ngSwitchCase="'outOfStock'">
                    <mat-icon class="error-icon">error</mat-icon>
                    <span class="error-text">{{ 'product.stockInfo.outOfStockMessage' | cxTranslate }}</span>
                  </div>
                  <div class="stock-info" *ngSwitchCase="'backorder'">
                    <span
                      class="text"
                      [class.instock-text]="
                        warehouse?.stockLevelStatus === 'inStock' ||
                        (warehouse?.stockLevelStatus === 'backorder' && warehouse?.stockLevel > 0)
                      "
                      [class.backorder-text]="
                        warehouse?.stockLevelStatus === 'backorder' && warehouse?.stockLevel === 0
                      "
                      >{{ warehouse.warehouseName }}({{ warehouse.stockLevel }})</span
                    >
                    <span class="leadtime-text" *ngIf="warehouse?.leadTime > 0"
                      >{{ 'product.stockInfo.leadtimeBackorder' | cxTranslate : { unit: warehouse?.leadTime } }}
                      {{ 'product.stockInfo.day' | cxTranslate }}</span
                    >
                  </div>

                  <div class="stock-info" *ngSwitchCase="'inStock'">
                    <span class="text instock-text">{{ warehouse.warehouseName }}({{ warehouse.stockLevel }})</span>
                    <span class="leadtime-text" *ngIf="warehouse?.leadTime > 0"
                      >{{ 'product.stockInfo.leadtimeInstock' | cxTranslate : { unit: warehouse?.leadTime } }}
                      {{ 'product.stockInfo.day' | cxTranslate }}</span
                    >
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </ng-template>
      </div>
      <div id="variantContainer" class="sku-variants-container">
        <!-- START OF SCROLL ////// START OF SCROLL ////// START OF SCROLL ////// START OF SCROLL //////  -->
        <div class="sku-variants-wrapper">
          <ng-container *ngIf="product">
            <div
              [ngStyle]="
                isMobileSize
                  ? {
                      'max-height': additionalHeight,
                      'overflow-y': 'scroll'
                    }
                  : {}
              "
              class="scroll-view"
              *ngIf="product"
            >
              <div *ngFor="let key of variantsKeys">
                <div #skuVariantsSelector class="sku-variants-selector" [ngClass]="key">
                  <div class="variant-name">
                    {{ key }}
                  </div>
                  <div
                    *ngIf="variants[key]"
                    class="variant-value-wrapper"
                    [class.colors]="isColors(filteredVariantsMap)"
                  >
                    <div *ngFor="let variant of filteredVariantsMap[key]">
                      <div class="variant-value-selector">
                        <div
                          class="variant-value-list"
                          (click)="changeVariant(variant.code, variant.variantSelected)"
                          [ngClass]="{
                            selected: variant.variantSelected,
                            color: variant.hasImage,
                            size: !variant.hasImage,
                            availableVVC: !variant.available
                          }"
                          [class.out-stock]="
                            (product?.stock?.stockLevelStatus == 'outOfStock' && variant.code == product.code) ||
                            variant?.option?.stock?.stockLevelStatus == 'outOfStock'
                          "
                          [class.backorder-stock]="
                            (product?.stock?.stockLevelStatus == 'backorder' &&
                              product?.stock?.stockLevel < 1 &&
                              variant.code == product.code) ||
                            (variant?.option?.stock?.stockLevelStatus == 'backorder' &&
                              variant?.option?.stock?.stockLevel < 1 &&
                              variant.available)
                          "
                          [class.discontinued-stock]="
                            (product?.stock?.stockLevelStatus === 'discontinued' && variant.code == product.code) ||
                            variant?.option?.stock?.stockLevelStatus === 'discontinued'
                          "
                          [class.discontinued-stock]="
                            (product?.stock?.stockLevelStatus === 'discontinued' && variant.code == product.code) ||
                            variant?.option?.stock?.stockLevelStatus === 'discontinued'
                          "
                        >
                          <cx-media
                            *ngIf="variant.hasImage"
                            matTooltip="{{ variant?.name }}"
                            [matTooltipPosition]="'below'"
                            matTooltipClass="image-tooltip"
                            aria-label="Image that displays a tooltip in bottom"
                            [alt]="variant?.name"
                            [container]="getImageRendition(variant.variantOptionQualifiers[0].image)"
                            [class.is-missing-fish]="businessType === 'fish'"
                          ></cx-media>
                          {{ variant.hasImage ? '' : variant.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="loading" class="rotating"></div>
            </div>
          </ng-container>
        </div>

        <!-- END OF SCROLL ////// END OF SCROLL ////// END OF SCROLL ////// END OF SCROLL ////// END OF SCROLL ////// -->
      </div>

      <div class="modal-footer" id="promotionStockstatus">
        {{ adjustVariantHeight() }}
        <div *ngIf="isMobileSize" [class.d-none]="!isMobileSize" class="promotion-and-stockstatus-mobile">
          <div [ngTemplateOutlet]="stockStatusArea"></div>
          <div [ngTemplateOutlet]="promotionArea"></div>
        </div>
        <div *ngIf="isMobileSize" [class.d-none]="!isMobileSize" class="add-to-cart-section-mobile">
          <div [ngTemplateOutlet]="addToCartSectionArea"></div>
        </div>

        <div *ngIf="!isMobileSize" [ngTemplateOutlet]="promotionArea"></div>
        <div *ngIf="!isMobileSize" [ngTemplateOutlet]="addToCartSectionArea"></div>
        <ng-template #promotionArea>
          <div class="stock-status-and-promotion">
            <app-product-promotions
              class="product-promotions"
              [promProductsFromGrid$]="productsFromGrid$"
              [fromGrid]="true"
            >
            </app-product-promotions>
          </div>
        </ng-template>
        <ng-template #addToCartSectionArea>
          <div id="addToCartHeight" class="add-to-cart-section">
            <div class="srp-price" *ngIf="showSrp">
              <span class="srp-price-label">{{ 'product.productList.srp' | cxTranslate }}</span>
              <span class="srp-price-value">{{ product?.srpPrice?.formattedValue }}</span>
            </div>

            <div class="dealer-price" *ngIf="!showSrp">
              <span class="dealer-price-label">
                {{ 'product.productList.dealerPrice' | cxTranslate }}
              </span>
              <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice; else dealerPriceReady">
                <div class="spinner-shimano" *ngIf="hasDealerPrice">
                  <div></div>
                </div>
                <div class="no-dealer-price no-dealer-price-pdp" *ngIf="!hasDealerPrice"></div>
              </div>
              <ng-template #dealerPriceReady>
                <div *ngIf="erpPromotions$ | async as erpproduct">
                  <ng-container
                    *ngIf="
                      erpproduct.dealerPrices.length > 0 &&
                        erpproduct.dealerPrices[0].promotionMessage &&
                        erpproduct.dealerPrices[0].promotionMessage !== '';
                      else displayDealerPrice
                    "
                  >
                    <span class="dealer-price-value erp-promo">{{ dealerPrice }}</span>
                    <span class="erp-promo-text">{{ erpproduct.dealerPrices[0].promotionMessage }}</span>
                  </ng-container>
                  <ng-template #displayDealerPrice>
                    <span *ngIf="dealerPrice" class="dealer-price-value">
                      {{ dealerPrice }}
                    </span>
                  </ng-template>
                </div>
              </ng-template>
            </div>
            <cx-item-counter
              *ngIf="hasStock && !loading"
              [allowZero]="false"
              [min]="0"
              [max]="999"
              [control]="addToCartForm.get('quantity')"
              (update)="updateCount($event)"
              (keypress)="numberOnly($event)"
              [moq]="minOrderQuantity"
              [readonly]="!dealerPrice || !hasStock || !minOrderQuantity"
            >
            </cx-item-counter>

            <button
              (click)="backorderCartCheck()"
              [disabled]="
                !dealerPrice || hasInvalidQuantity || !hasStock || product?.stock?.stockLevelStatus === 'discontinued'
              "
              type="button"
              class="btn btn-primary btn-block btn-add-to-cart"
              [ngClass]="{
                rotating: addToCartInprogress
              }"
            >
              <ng-container *ngIf="!addToCartInprogress; else showSpinner">
                <mat-icon svgIcon="add-to-cart"></mat-icon>
              </ng-container>
              <ng-template #showSpinner></ng-template>
            </button>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showBackorderCartModal" class="modal-container backorder-cart-modal-container modal-lg">
  <div class="modal-content">
    <div class="modal-header d-flex align-items-center">
      <h4 class="modal-title">{{ 'cart.backOrderCartModal.title' | cxTranslate }}</h4>
      <button
        class="close"
        aria-label="Close"
        (click)="closeModal('Cross click')"
        [disabled]="addToCartInprogressModal"
      >
        <mat-icon svgIcon="modal-x-icon"></mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <p [innerHTML]="'cart.backOrderCartModal.description' | cxTranslate"></p>

      <div class="backorder-table">
        <table class="backorder-product-table">
          <tr class="header">
            <th>{{ 'cart.backOrderCartModal.skuLabel' | cxTranslate }}</th>
            <th>{{ 'cart.backOrderCartModal.totalQtyLabel' | cxTranslate }}</th>
            <th>{{ 'cart.backOrderCartModal.shipmentDateLabel' | cxTranslate }}</th>
            <th>{{ 'cart.backOrderCartModal.addToCartLabel' | cxTranslate }}</th>
          </tr>
          <tr *ngFor="let backorder of backorderEntries['inventoryBackorderList']; let index = index">
            <td>
              <a href="/orders?item={{ backorder.productId }}&view=backorder" target="_blank">{{
                backorder?.productId
              }}</a>
            </td>
            <td>{{ backorder?.quantity }}</td>
            <td>
              {{ backorder?.availDate | date : dateFormatted }}
            </td>
            <td>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="backorder.checkBox"
                  [checked]="backorder.checkBox"
                  [value]="backorder.checkBox"
                  (change)="checkboxUpdate()"
                />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="modal-footer justify-content-sm-between justify-content-md-end">
      <button
        type="button"
        class="btn secondary-btn"
        [ngClass]="activeLanguage$ | async"
        [class.disabled]="addToCartInprogressModal"
        (click)="backToProductModal()"
        [disabled]="addToCartInprogressModal"
      >
        {{ 'cart.backOrderCartModal.cancelBtn' | cxTranslate }}
      </button>
      <button
        type="button"
        class="btn primary-btn"
        [ngClass]="activeLanguage$ | async"
        [class.rotating]="addToCartInprogressModal"
        (click)="saveBackorder()"
        [disabled]="filteredEntries?.length < 1 && nonBackorder?.length < 1"
      >
        <ng-container *ngIf="!addToCartInprogressModal; else showSpinner">
          {{ 'cart.backOrderCartModal.addToCartBtn' | cxTranslate }}
        </ng-container>
        <ng-template #showSpinner></ng-template>
      </button>
    </div>
  </div>
</div>
